;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('LineService', LineService)

  LineService.$inject = [
    // Angular
    '$uibModal',

    // Managers
    'InvoiceManager', 'CategoryManager',

    // Services
    'PreferencesService', 'SessionService'

  ]

  function LineService (
    // Angular
    $uibModal,

    // Managers
    InvoiceManager, CategoryManager,

    // Services
    PreferencesService, SessionService

  ) {
    var self = this

    self.$init = function () {
      CategoryManager.get(
        CategoryManager
          .query()
          // .select(SessionService.getCompany(), 'company')
      ).then(function (data) {
        self.categories = _.map(data.data, 'label')
      })
    }

    self.$init()

    /**
     * Create new line on invoice
     * @param {object} invoice
     * @param {string} type
     * @param {*} rubrics
     * @param {boolean} manageSubcontracts
     */
    function promptLineCreate (invoice, type, rubrics, manageSubcontracts) {
      return promptLineEdit(invoice, null, 'new', type, rubrics, manageSubcontracts)
    }

    function promptLineProductTypeEdit () {
      return $uibModal.open({
        size: 'm',
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: '/app/common/services/line/modals/edit-product-type/edit-product-type.template.html',
        controller: 'EditProductTypeController'
      }).result
    }

    /**
     * Pagination temporaire 'tmp' résolue pour une modale d'édition de ligne :
     * son watcher $rootScope est retiré dès que la modale est fermée / annulée
     * (ou que son ouverture échoue), y compris si la pagination est résolue après coup.
     */
    function createTmpPagination () {
      let pagination = null
      let finished = false
      function destroy () {
        finished = true
        if (pagination) pagination.destroy()
      }
      return {
        resolve: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp').then(function (p) {
            pagination = p
            if (finished) p.destroy()
            return p
          })
        }],
        destroyOn: function (modalInstance) {
          // Les deux callbacks : l'annulation (rejet) ne doit pas remonter en rejet non géré
          modalInstance.result.then(destroy, destroy)
        }
      }
    }

    function promptLineEdit (invoice, line, action, type, rubrics, manageSubcontract) {
      const tmpPagination = createTmpPagination()
      const modalInstance = $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        resolve: {
          manageSubcontract: [function () {
            return manageSubcontract
          }],
          type: [function () {
            if (!type) {
              return 'invoice'
            }
            return ('' + type).toLowerCase()
          }],
          grant: _.get(line, 'grant', false),
          rubrics: function () { return rubrics },
          invoice: function () { return invoice },
          line: function () { return line },
          vatList: ['PreferencesService', function (PreferencesService) {
            return PreferencesService.getCompanyPrefs().then(function (prefs) {
              return prefs.vats
            })
          }],
          categories: function () { return self.categories },
          action: function () {
            return action || 'edit'
          },
          manager: ['InvoiceLineManager', 'QuoteLineManager', 'CreditNoteLineManager', function (InvoiceLineManager, QuotelineManager, CreditNoteLineManager) {
            switch (type) {
              case 'creditNote':
              case 'creditnote':
              case 'CreditNote':
                return CreditNoteLineManager
              case 'quote':
              case 'Quote':
              case 'invoice':
              case 'Invoice':
              default:
                return InvoiceLineManager
            }
          }],
          pagination: tmpPagination.resolve
        },
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: 'AddLineController'
      })
      tmpPagination.destroyOn(modalInstance)
      return modalInstance.result
    }

    function prompteLineCreateGrant (invoice, type, rubrics, manageSubcontracts) {
      return promptLineEditGrant(invoice, null, 'new', type, rubrics, manageSubcontracts)
    }
    function promptLineEditGrant (invoice, line, action, type, rubrics, manageSubcontract) {
      const tmpPagination = createTmpPagination()
      const modalInstance = $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        resolve: {
          manageSubcontract: [function () {
            return manageSubcontract
          }],
          grant: true,
          type: [function () {
            if (!type) {
              return 'invoice'
            }
            return ('' + type).toLowerCase()
          }],
          rubrics: function () { return rubrics },
          invoice: function () { return invoice },
          line: function () { return line },
          vatList: ['PreferencesService', function (PreferencesService) {
            return PreferencesService.getCompanyPrefs().then(function (prefs) {
              return prefs.vats
            })
          }],
          categories: function () { return self.categories },
          action: function () {
            return action || 'edit'
          },
          manager: ['InvoiceLineManager', 'QuoteLineManager', 'CreditNoteLineManager', function (InvoiceLineManager, QuotelineManager, CreditNoteLineManager) {
            switch (type) {
              case 'creditNote':
              case 'creditnote':
              case 'CreditNote':
                return CreditNoteLineManager
              case 'quote':
              case 'Quote':
              case 'invoice':
              case 'Invoice':
              default:
                return InvoiceLineManager
            }
          }],
          pagination: tmpPagination.resolve
        },
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: 'AddLineController'
      })
      tmpPagination.destroyOn(modalInstance)
      return modalInstance.result
    }

    _.extend(self, {
      promptLineCreate: promptLineCreate,
      prompteLineCreateGrant: prompteLineCreateGrant,
      promptLineEdit: promptLineEdit,
      promptLineProductTypeEdit: promptLineProductTypeEdit,
      promptLineEditGrant: promptLineEditGrant
    })
  }
})(window.angular, window._, window.moment)
